// Specialized catalog kinds need their nested shape as well as their enum name.
// Keep this contract in parity with shared-agent-config/src/codex/validate.rs.
export function controlValueContract(agentId, entry) {
    if (agentId !== "codex" || entry?.pointer !== "/rules/prefix_rules"
        || entry.valueKind !== "MANAGED_AGENT_CONFIG_VALUE_KIND_PREFIX_RULES") return {};
    const decisions = entry.ruleDecisions || [];
    const nonEmptyString = { type: "string", minLength: 1 };
    return {
        valueFormat: "an array of rules with pattern (a non-empty array of {token: string} or {any_of: string[]} objects), decision, and optional non-empty justification; no other fields. Tokens and alternatives must be non-empty. Decisions: " + decisions.join(", "),
        exampleValue: decisions.length ? [{ pattern: [{ token: "git" }, { token: "push" }], decision: decisions.includes("prompt") ? "prompt" : decisions[0] }] : [],
        valueSchema: {
            type: "array",
            items: {
                type: "object", additionalProperties: false, required: ["pattern", "decision"],
                properties: {
                    pattern: {
                        type: "array", minItems: 1,
                        items: {
                            oneOf: [
                                { type: "object", additionalProperties: false, required: ["token"], properties: { token: nonEmptyString } },
                                { type: "object", additionalProperties: false, required: ["any_of"], properties: { any_of: { type: "array", minItems: 1, items: nonEmptyString } } },
                            ],
                        },
                    },
                    decision: { type: "string", enum: decisions },
                    justification: nonEmptyString,
                },
            },
        },
    };
}

export function describeControlRejections(agentId, catalog, rejections) {
    return rejections.map((rejection) => {
        const pointer = rejection.pointer || "(unknown setting)";
        const reason = rejection.message || rejection.reason || "rejected";
        const contract = controlValueContract(agentId, catalog?.settings?.find((entry) => entry.pointer === rejection.pointer));
        return `${pointer}: ${reason}${contract.valueFormat ? `. Expected ${contract.valueFormat}. Example: ${JSON.stringify(contract.exampleValue)}` : ""}`;
    }).join("; ");
}
